/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StockAdjustment } from '../../models/stock-adjustment';

export interface StockAdjustmentsControllerFindById$Params {
  id: string;
}

export function stockAdjustmentsControllerFindById(http: HttpClient, rootUrl: string, params: StockAdjustmentsControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<StockAdjustment>> {
  const rb = new RequestBuilder(rootUrl, stockAdjustmentsControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StockAdjustment>;
    })
  );
}

stockAdjustmentsControllerFindById.PATH = '/stock/adjustments/{id}';
